import { IProductsSetAction, PRODUCTS_ACTION_SET } from './types';
import { IRestProduct } from 'app/types/rest/IRestProduct';

export const productsSetAction = (
    products: IRestProduct[]
): IProductsSetAction => {
    return {
        type: PRODUCTS_ACTION_SET,
        products
    }
};
